import React from "react";
import { Link } from "react-router-dom";
import { ABOUT_IMG02, ABOUT_IMG03, ABOUT_SHAPE01, CHECK_ICON } from "../../lib/assets";
import { HOME_EXPERTISE } from "../../content/siteContent";

export const AboutTwo = () => {
  return (
    <section className="about-area-two pt-110 pb-120">
      <div className="container">
        <div className="row align-items-center justify-content-center">
          <div className="col-lg-7 col-md-9 order-0 order-lg-2">
            <div className="about-img-two">
              <div className="main-img">
                <img src={ABOUT_IMG02} alt="" />
              </div>
              <img src={ABOUT_IMG03} alt="" />
            </div>
          </div>

          <div className="col-lg-5">
            <div className="about-content-two">
              <div className="section-title mb-30 tg-heading-subheading animation-style2">
                <span className="sub-title tg-element-title">
                  {HOME_EXPERTISE.eyebrow}
                </span>
                <h2 className="title tg-element-title">
                  {HOME_EXPERTISE.title}
                </h2>
              </div>
              <p>{HOME_EXPERTISE.description}</p>

              <div className="about-list">
                <ul className="list-wrap">
                  {HOME_EXPERTISE.checklist.map((item) => (
                    <li key={item}>
                      <img src={CHECK_ICON} alt="" />
                      {item}
                    </li>
                  ))}
                </ul>
              </div>

              <div className="success-wrap">
                <ul className="list-wrap">
                  {HOME_EXPERTISE.stats.map((item) => (
                    <li key={item.label}>
                      <h2 className="count">{item.value}</h2>
                      <p>{item.label}</p>
                    </li>
                  ))}
                </ul>
              </div>

              <Link to="/about" className="btn transparent-btn">
                Learn More
              </Link>
            </div>
          </div>
        </div>
      </div>

      <div className="about-shape-wrap">
        <img src="/images/home/dots.png" alt="" />
        <img src={ABOUT_SHAPE01} alt="" />
      </div>
    </section>
  );
};
